import React, { useContext, useState, useEffect, useRef } from 'react'
import CustomTable from '@/product/components/molecules/CustomTable'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'
import AlertContext from '@/product/context/alert/alertContext'
import UserCommonContext from '@/product/context/userCommon/commonContext'
import Loaders from '@/product/components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'

const SellerNotesTab = (props) => {
    const settingcontext = useContext(SettingContext)
    const usercommoncontext = useContext(UserCommonContext)
    const alertContext = useContext(AlertContext)
    const authContext = useContext(AuthContext)

    const { setAlert } = alertContext
    const { user } = authContext

    const { allLocations, getGlobalVariable } = useContext(CustomCommonContext)
    const [isLoading, setIsLoading] = useState(true)

    const {
        searchTableAction,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const { getPreviousData, clearPreviousData, previous_data } =
        usercommoncontext

    const [changeStatus, setChangeStatus] = useState(false)
    const [changeDelStatus, setChangeDelStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const changeChangeDelStatus = () => {
        setChangeDelStatus(!changeDelStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: 'desc',
            orderby: 'un.id',
            primaryTable: 'user_notes',
            tableJoins: [
                {
                    baseTable: 'employees',
                    joinType: 'left',
                    baseJoinField: 'id',
                    connectJoinField: 'admin_id',
                },
            ],
            filters: {
                user_id: {
                    type: 'in',
                    value: '',
                    field: 'un.user_id',
                },
                active: {
                    type: 'in',
                    value: 1,
                    field: 'un.active',
                },
            },
        },
        onSubmit: (values) => {
            searchTableFetch(values, 'user_notes')
            setIsLoading(true)
        },
    })

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'user_notes') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                setIsLoading(false)
            } else if (search_fetch_data.from === 'edit_notes') {
                if (search_fetch_data.records.length) {
                    let editData = search_fetch_data.records[0]
                    notesFormik.values.admin_id = editData.admin_id
                    notesFormik.values.user_id = editData.user_id
                    notesFormik.values.id = editData.id
                    notesFormik.values.notes = editData.notes
                    setChangeStatus(true)
                }
            }
        }
    }, [search_fetch_data])

    const formikSelection = useFormik({
        initialValues: {
            id: 0,
            active: 0,
            table: 'user_notes',
        },
        onSubmit: (values) => {
            searchTableAction(values, false, 'deletenote')
            setIsLoading(true)
        },
    })

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                setTableBody([])
                searchTableFetch(formikView.values, 'user_notes')
                resetForm()
                setIsLoading(false)
            } else if (
                responseStatusSetting.from === 'deletenote' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeDelStatus(false)
                setTableBody([])
                searchTableFetch(formikView.values, 'user_notes')
            }
        }
    }, [responseStatusSetting])

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.id = data
        if (action === 'delete') {
            setChangeDelStatus(true)
        }
    }

    const tableActions = [
        {
            label: 'Delete',
            icon: <span className="material-icons">cancel</span>,
            onclick: onSelectMultiProducts,
            type: 'delete',
        },
    ]

    const onClickEdit = (id, secondaryID, type) => {
        searchTableFetch(
            {
                page: 1,
                limit: 20,
                order: '',
                orderby: '',
                primaryTable: 'user_notes',
                tableJoins: [
                    {
                        baseTable: 'employees',
                        joinType: 'left',
                        baseJoinField: 'id',
                        connectJoinField: 'user_id',
                    },
                ],
                filters: {
                    user_id: {
                        type: 'in',
                        value: secondaryID,
                        field: 'un.user_id',
                    },
                    id: {
                        type: 'in',
                        value: id,
                        field: 'un.id',
                    },
                },
            },
            'edit_notes'
        )
    }

    const notesValidation = Yup.object({
        notes: Yup.string().required('Required'),
    })

    const notesFormik = useFormik({
        initialValues: {
            id: 0,
            user_id: 0,
            admin_id: user?.emp_id ? user.emp_id : user?.admin_id || 0,
            username: user?.emp_firstname + ' ' + user?.emp_lastname,
            notes: '',
            active: 1,
            table: 'user_notes',
        },
        validationSchema: notesValidation,
        onSubmit: (values) => {
            values.username = user?.emp_firstname + ' ' + user?.emp_lastname
            searchTableAction(values)
            setIsLoading(true)
        },
    })

    const notesField = {
        formik: notesFormik,
        data: [
            {
                label: 'Notes',
                type: 'textarea',
                placeholder: 'Enter notes',
                class: 'col-12',
                name: 'notes',
            },
        ],
    }
    const getMultipleAction = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit User',
            },
        ]

        return actionPush
    }

    useEffect(() => {
        if (props?.data?.id) {
            formikView.values.filters.user_id.value = props.data.id
            notesFormik.values.user_id = props.data.id
        } else {
            resetForm()
        }
        searchTableFetch(formikView.values, 'user_notes')
        setIsLoading(true)
        setChangeStatus(false)
    }, [props.data])

    const resetForm = () => {
        notesFormik.values.admin_id = user?.emp_id
            ? user.emp_id
            : user?.admin_id || 0
        notesFormik.values.user_id = props?.data?.id ? props.data.id : 0
        notesFormik.values.id = 0
        notesFormik.values.notes = ''
        notesFormik.handleReset()
    }

    // const searchInfo = {
    //     formik: formikView,
    //     data: [
    //         {
    //             label: 'Report Name',
    //             placeholder: 'Enter Report Name',
    //             class: 'col-md-4 col-sm-6 col-12',
    //             type: 'text',
    //             name: 'report_name',
    //             filter: true,
    //         },
    //     ],
    // }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
            filterable: true,
            filterField: 'un.id',
        },
        {
            field: 'notes',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Notes',
            filterable: true,
            filterField: 'un.notes',
        },
        {
            field: 'as_employees_emp_firstname,as_employees_emp_lastname',
            type: '',
            firstChild: true,
            sort: false,
            filterField: 'emp_firstname,emp_lastname',
            disablePadding: false,
            label: 'Created By',
        },
        {
            field: 'created_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            filterField: 'un.created_at',
            disablePadding: false,
            label: 'Created At',
        },
        {
            field: 'updated_at',
            type: 'datetime',
            firstChild: true,
            sort: true,
            filterField: 'un.updated_at',
            disablePadding: false,
            label: 'Updated At',
        },
    ]

    tableValues.push({
        field: 'action',
        type: 'button',
        clickID: 'id',
        secondaryClickID: 'user_id',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Action',
        isMultiple: getMultipleAction(),
    })

    const closeFunction = () => {
        changeChangeStatus()
        resetForm()
    }

    return (
        <>
            <div className="dashboard staticPages">
                <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4">
                    <Button
                        id="userManage_dynamic_add"
                        variant="outlined"
                        className="btnOutlined mr-2"
                        onClick={() => setChangeStatus(true)}
                    >
                        <span className="material-icons">notes</span>
                        Add Notes
                    </Button>
                </div>

                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <CustomTable
                        formik={formikView.values}
                        tableBody={tableBody}
                        tableValues={tableValues}
                        tableActions={tableActions}
                        allData={search_fetch_data}
                        fromVariable={'user_notes'}
                        changeTableFunction={searchTableFetch}
                    />
                )}
            </div>
            <CustomDialog
                title={notesFormik.values.id ? 'Edit Notes' : 'Add Notes'}
                open={changeStatus}
                className="invoiceNotes"
                function={closeFunction}
            >
                <h5>Add any specific information related to users here.</h5>
                <div className="row">{mapData(notesField)}</div>
                <div className="actionWrapper">
                    <Button
                        id="userManage_cancel"
                        onClick={() => {
                            changeChangeStatus()
                            resetForm()
                        }}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={notesFormik.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="userView_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title={'Change status'}
                open={changeDelStatus}
                openFunction={changeChangeDelStatus}
            >
                <h5>Are you sure you want to change the status</h5>
                <div className="actionWrapper">
                    <Button onClick={() => changeChangeDelStatus()}>
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton type="submit" label="Confirm" />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}
export default SellerNotesTab
